import { FC, HTMLProps, useEffect, useRef } from 'react';
import { IonSpinner } from '@ionic/react';
import { Box } from '@mui/material';
import classNames from 'classnames';
import styles from './index.module.scss';

interface ObserverProps extends Pick<HTMLProps<HTMLDivElement>, 'className'> {
	isLoading: boolean;
	onObserve: () => void;
}

export const Observer: FC<ObserverProps> = ({ isLoading, onObserve, className }) => {
	const observerRef = useRef(null);

	const observerCallback = (entries: Array<IntersectionObserverEntry>) => {
		entries.forEach((entry: IntersectionObserverEntry) => {
			if (entries[0].intersectionRatio <= 0) return;
			if (onObserve && entry.isIntersecting) {
				onObserve();
			}
		});
	};

	useEffect(() => {
		let observer: IntersectionObserver | null = null;

		if (observerRef.current) {
			const options = {
				threshold: 1,
			};

			observer = new IntersectionObserver(observerCallback, options);
			observer.observe(observerRef.current);
		}

		return () => {
			if (observerRef.current && observer) {
				observer.unobserve(observerRef.current);
			}
		};
	}, [observerRef.current]);

	return (
		<div className={classNames(styles.wrapper, className)}>
			{isLoading ? (
				<IonSpinner className={styles.loader} name="dots" />
			) : (
				<Box className={styles.observer} ref={observerRef} />
			)}
		</div>
	);
};
